import React from "react";
import Skeleton from "react-loading-skeleton";

const ProductCardSkeleton: React.FC = () => {
  return (
    <div className="product-card-skeleton">
      <div className="product-card-skeleton__image">
        <Skeleton height="100%" />
      </div>
      <div className="product-card-skeleton__content">
        <Skeleton width="60%" height={14} />
        <Skeleton height={20} style={{ margin: "4px 0" }} />
        <Skeleton height={20} />
        <Skeleton
          width="110px"
          height={32}
          borderRadius="4px"
          style={{ marginTop: "auto" }}
        />
      </div>
    </div>
  );
};

export default ProductCardSkeleton;
